export default from './restriction';



// WEBPACK FOOTER //
// ./app/components/restriction/index.js